module.exports = __webpack_public_path__ + "img/vf2.84553390.png";